{
  "type": "object",
  "name": "voucher",
  "class": "py-4",
  "definitions": [
    {
      "type": "container",
      "title": "Belegdaten",
      "definitions": [
        {
          "type": "date",
          "title": "",
          "name": "detail.belegdatum",
          "class": "color-light"
        },
        {
          "type": "entity",
          "title": "",
          "name": "detail.ktostamm",
          "endpoint": "",
          "format": "{{number}} - {{name}}",
          "class": "font-bold text-lg"
        },
        {
          "type": "string",
          "title": "Rechnungs-Nr.: ",
          "name": "detail.belegnummer"
        },
        {
          "type": "string",
          "title": "Fremdbelegs-Nr.: ",
          "name": "detail.bezugsnummer"
        }
      ]
    },
    {
      "type": "string",
      "title": "Belegart",
      "name": "detail.belegart"
    },
    {
      "type": "entity",
      "title": "Baustelle",
      "name": "detail.ktostamm_lief",
      "format": "{{number}} - {{name}}"
    },
    {
      "type": "date",
      "title": "Fälligkeit",
      "name": "detail.faelligkeit"
    },
    {
      "type": "currency",
      "title": "Netto",
      "name": "detail.nettoBetrag",
      "code": "EUR",
      "titleClass": "text-right"
    },
    {
      "type": "currency",
      "title": "Brutto",
      "name": "detail.bruttoBetrag",
      "code": "EUR",
      "titleClass": "text-right"
    }
  ]
}
